import React, {FC, useEffect, useRef, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {
  fetchData,
  fetchFormData,
  getTranslatedValue,
  hasSpecialCharacters,
  isOnlyNumber,
  toasterrormsg,
  toastsuccessmsg,
} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {MixedWidget22} from '../../../_metronic/partials/widgets'
import Swal from 'sweetalert2'
import {AddSpaceHeader} from './AddSpaceHeader'
import clsx from 'clsx'
import {useMediaReorder, ReorderButton, UploadedImageGrid, NewImageGrid} from '../mediaReorder'
import {Calendar, Views, momentLocalizer, SlotInfo, CalendarProps} from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import {FileUploader} from 'react-drag-drop-files'
import PriceInput from '../PriceInput'
import SpecialPriceDays, {SpecialPriceDay} from '../SpecialPriceDays'
import JoditEditor from 'jodit-react'
import {config} from '../../../reusable'
import imageCompression from 'browser-image-compression'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Tr} from '../../../_metronic/i18n/Tr'
import StepErrorAlert from '../StepErrorAlert'
import {useLang} from '../../../_metronic/i18n/Metronici18n'

const ViewRentableSpaces: FC = () => {
  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '4') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const editorRef = useRef(null)
  const inputfileRef = useRef(null)
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const editSpacerentalId = (location.state as any)?.spacerentalId || ''

  const primaryLanguage = localStorage.getItem('primaryLanguage')
  // -------- state start ------------
  const [editRentableSpaceId, setEditRentableSpaceId] = useState('')
  const [tab, setTab] = useState('BasicInfo') // BasicInfo, GeneralInfo, FacilityAndServices, PricingAndAvailability, RentableSpacePhotos, AdditionalOptions
  const [priceTab, setPriceTab] = useState('RegularPrice') // RegularPrice, SpecialPrice, Availability
  const [priceStepError, setPriceStepError] = useState('')
  useEffect(() => {
    setPriceStepError('')
  }, [priceTab])
  const [disable, setDisable] = useState(false)
  const [spaceDetail, setSpaceDetail] = useState([])
  const [spaceDetails, setSpaceDetails] = useState([])
  const [primLanguage, setPrimLanguage] = useState('')
  const [rentableSpaceNameEN, setRentableSpaceNameEN] = useState('')
  const [rentableSpaceNameRU, setRentableSpaceNameRU] = useState('')
  const [rentableSpaceNameUZ, setRentableSpaceNameUZ] = useState('')
  const [generalInformationEN, setGeneralInformationEN] = useState('')
  const [generalInformationRU, setGeneralInformationRU] = useState('')
  const [generalInformationUZ, setGeneralInformationUZ] = useState('')
  const [spaceInformationEN, setSpaceInformationEN] = useState('')
  const [spaceInformationRU, setSpaceInformationRU] = useState('')
  const [spaceInformationUZ, setSpaceInformationUZ] = useState('')
  const [maxPeople, setMaxPeople] = useState('')
  const [baseCharge, setBaseCharge] = useState('')
  const [baseChargeByHours, setBaseChargeByHours] = useState('')
  const [extraPeopleCharge, setExtraPeopleCharge] = useState('')
  const [availableSpace, setAvailableSpace] = useState('')
  const [standardPeople, setStandardPeople] = useState('')
  const [isSmokingAllowed, setIsSmokingAllowed] = useState('No')
  const [byDay, setByDay] = useState(true)
  const [byHours, setByHours] = useState(true)
  const [startAvailableDate, setStartAvailableDate] = useState('')
  const [endAvailableDate, setEndAvailableDate] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [en_title, setEn_title] = useState('')
  const [ru_title, setRu_title] = useState('')
  const [uz_title, setUz_title] = useState('')
  const [hourlyType, setHourlyType] = useState('Hourly')
  const [peopleType, setPeopleType] = useState('People')
  const [hourlyMondayPrice, setHourlyMondayPrice] = useState('0')
  const [hourlyTuesdayPrice, setHourlyTuesdayPrice] = useState('0')
  const [hourlyWednedayPrice, setHourlyWednesdayPrice] = useState('0')
  const [hourlyThurdayPrice, setHourlyThursdayPrice] = useState('0')
  const [hourlyFridayPrice, setHourlyFridayPrice] = useState('0')
  const [hourlySaturdayPrice, setHourlySaturdayPrice] = useState('0')
  const [hourlySundayPrice, setHourlySundayPrice] = useState('0')
  const [peopleMondayPrice, setPeopleMondayPrice] = useState('0')
  const [peopleTuesdayPrice, setPeopleTuesdayPrice] = useState('0')
  const [peopleWednedayPrice, setPeopleWednedayPrice] = useState('0')
  const [peopleThurdayPrice, setPeopleThurdayPrice] = useState('0')
  const [peopleFridayPrice, setPeopleFridayPrice] = useState('0')
  const [peopleSaturdayPrice, setPeopleSaturdayPrice] = useState('0')
  const [peopleSundayPrice, setPeopleSundayPrice] = useState('0')
  const [specialPrice, setSpecialPrice] = useState([]) as any
  const [minimumNumberOfPeople, setMinimumNumberOfPeople] = useState('')
  const [minimumHoursForReservation, setMinimumHoursForReservation] = useState('')

  const [editIndex, setEditIndex] = useState(-1)
  const handleByDayChange = (e: any) => {
    setByDay(e.target.checked) // Toggle the checked state
  }
  const handleByHoursChange = (e: any) => {
    setByHours(e.target.checked) // Toggle the checked state
  }
  const [inputImage, setInputImage] = useState([]) as any
  const [uploadedImage, setUploadedImage] = useState([]) as any;
  const reorder = useMediaReorder({
      type: 'rentablespace',
      inputImage,
      setInputImage,
      uploadedImage,
      setUploadedImage,
  });

  // handle modal show & hide
  const [show, setShow] = useState(false)
  const handleClose = () => {
    setShow(false)
    setEditRentableSpaceId('')
    cleanStates()
  }
  const handleShow = () => setShow(true)

  // amenities list state start
  const [amenitiesList, setAmenitiesList] = useState([])
  const [amenitiesSelectedOptions, setAmenitiesSelectedOptions] = useState<any>([])
  const amenityId = amenitiesSelectedOptions
    ? amenitiesSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  // amenities list state end

  // available type list state start
  const availableTypeList = [
    {label: t('Available'), value: 'available'},
    {label: t('Unavailable'), value: 'unavailable'},
  ]

  const [availableTypeSelectedOptions, setAvailableTypeSelectedOptions] = useState<any>()
  // available type list state end

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9)
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayRentableSpaceList, setDisplayRentableSpaceList] = useState([])
  const [pageNumbersList, setPageNumberList] = useState([1])

  const [additionalFields, setAdditionalFields] = useState([
    {
      en_name: '',
      ru_name: '',
      uz_name: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
      maxUseCapacity: '',
      spacePrice: '',
      additionalImage: null,
      thumbPath: '',
      image: '',
    },
  ]) as any

  const handleAddAdditionalField = () => {
    setAdditionalFields([
      ...additionalFields,
      {
        en_name: '',
        ru_name: '',
        uz_name: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
        maxUseCapacity: '',
        spacePrice: '',
        additionalImage: null,
        thumbPath: '',
        image: '',
      },
    ])
  }

  const handleRemoveAdditionalField = (index: any) => {
    if (index > 0) {
      const updatedFields = additionalFields.filter((_: any, i: any) => i !== index)
      setAdditionalFields(updatedFields)
    }
  }

  const handleAdditionalInputChange = (index: any, name: any, value: any) => {
    const updatedFields = additionalFields.map((field: any, i: any) =>
      i === index ? {...field, [name]: value} : field
    )
    setAdditionalFields(updatedFields)
  }

  const handleAdditionalImageChange = async (index: any, image: any) => {
    const updatedFields = [...additionalFields]

    let param = new FormData()
    if (image) {
      param.append('additionalSpaceImage', image)
    }
    var res = await fetchFormData('public/additionalSpaceImageUpload', param)
    if (res.status == '200') {
      const data = res.data[0]
      updatedFields[index].image = data['imageName']
      updatedFields[index].thumbPath = data['thumbPath']
      updatedFields[index].additionalImage = image
    }
    setAdditionalFields(updatedFields)
  }
  const handleRemoveAdditionalImage = async (index: number) => {
    const updatedFields = [...additionalFields]
    updatedFields[index].image = ''
    updatedFields[index].thumbPath = ''
    updatedFields[index].additionalImage = ''
    setAdditionalFields(updatedFields)
  }
  const [validationErrors, setValidationErrors] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      fromDate: '',
      toDate: '',
      hourlyMondayPrice: '',
      hourlyTuesdayPrice: '',
      hourlyWednedayPrice: '',
      hourlyThurdayPrice: '',
      hourlyFridayPrice: '',
      hourlySaturdayPrice: '',
      hourlySundayPrice: '',
      peopleMondayPrice: '',
      peopleTuesdayPrice: '',
      peopleWednedayPrice: '',
      peopleThurdayPrice: '',
      peopleFridayPrice: '',
      peopleSaturdayPrice: '',
      peopleSundayPrice: '',
    },
  ])
  const [error, setError] = useState([
    {
      rentableSpaceNameEN: '',
      rentableSpaceNameRU: '',
      rentableSpaceNameUZ: '',
      spaceInformationEN: '',
      spaceInformationRU: '',
      spaceInformationUZ: '',
      generalInformationEN: '',
      generalInformationRU: '',
      generalInformationUZ: '',
      maxPeople: '',
      amenityId: '',
      viewId: '',
      baseCharge: '',
      baseChargeByHours: '',
      extraPeopleCharge: '',
      extraPeopleChargeByHour: '',
      strikePrice: '',
      availableSpace: '',
      standardPeople: '',
      bookingType: '',
      availableDate: '',
      inputImage: '',
      additionalImage: '',
      minimumNumberOfPeople: '',
      minimumHoursForReservation: '',
    },
  ])
  const [errors, setErrors] = useState([
    {
      en_name: '',
      ru_name: '',
      uz_name: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
      maxUseCapacity: '',
      spacePrice: '',
      additionalImage: '',
    },
  ])
  // ----------- state end ------------

  // ----------------------- functions ----------------------------
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2)
    let startPage = Math.max(1, currentPage - halfMaxPages)
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1)
    }

    // Generate the list of page numbers
    const pageNumbers = []
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = spaceDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit
        } else {
          tolimi = pageId * limit + limit
        }
      } else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = spaceDetails.slice(tmp, tolimi)
      setDisplayRentableSpaceList(tmpdata)
    }
  }
  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const removeErrors = (index: any, fieldName: any) => {
    let newError = [...errors] as any
    if (!newError[index]) {
      newError[index] = {}
    }
    newError[index][fieldName] = '' // Clear error
    setErrors(newError)
  }
  const clearValidationError = (err: any) => {
    var tmp = [...validationErrors] as any
    tmp[0][err] = ''
    setValidationErrors(tmp)
  }
  const formatDate = (date: any) => {
    return moment(date).format('DD-MM-YYYY h:mm A')
  }

  const checkDateConflict = () => {
    for (let i = 0; i < specialPrice.length; i++) {
      // Skip checking the date conflict for the row being edited
      if (editIndex > -1 && i === editIndex) {
        continue
      }
      const existingItem = specialPrice[i]
      const existingFromDate = new Date(existingItem.fromDate)
      const existingToDate = new Date(existingItem.toDate)
      const currentFromDate = new Date(fromDate)
      const currentToDate = new Date(toDate)
      // Check if the current date range overlaps with any other existing date range
      if (
        (currentFromDate >= existingFromDate && currentFromDate <= existingToDate) ||
        (currentToDate >= existingFromDate && currentToDate <= existingToDate) ||
        (currentFromDate <= existingFromDate && currentToDate >= existingToDate)
      ) {
        toasterrormsg(t('Date conflict: The selected date range overlaps with an existing entry.'))
        return false
      }
    }
    return true
  }
  // Hourly special prices are only mandatory when a regular hourly price is set
  const isHourlySpecialPriceRequired = byHours && Number(baseChargeByHours) > 0
  const hourlySpecialDays: SpecialPriceDay[] = [
    {key: 'hourlyMondayPrice', label: 'Monday', value: hourlyMondayPrice, setValue: setHourlyMondayPrice},
    {key: 'hourlyTuesdayPrice', label: 'Tuesday', value: hourlyTuesdayPrice, setValue: setHourlyTuesdayPrice},
    {key: 'hourlyWednedayPrice', label: 'Wednesday', value: hourlyWednedayPrice, setValue: setHourlyWednesdayPrice},
    {key: 'hourlyThurdayPrice', label: 'Thursday', value: hourlyThurdayPrice, setValue: setHourlyThursdayPrice},
    {key: 'hourlyFridayPrice', label: 'Friday', value: hourlyFridayPrice, setValue: setHourlyFridayPrice},
    {key: 'hourlySaturdayPrice', label: 'Saturday', value: hourlySaturdayPrice, setValue: setHourlySaturdayPrice},
    {key: 'hourlySundayPrice', label: 'Sunday', value: hourlySundayPrice, setValue: setHourlySundayPrice},
  ]
  const peopleSpecialDays: SpecialPriceDay[] = [
    {key: 'peopleMondayPrice', label: 'Monday', value: peopleMondayPrice, setValue: setPeopleMondayPrice},
    {key: 'peopleTuesdayPrice', label: 'Tuesday', value: peopleTuesdayPrice, setValue: setPeopleTuesdayPrice},
    {key: 'peopleWednedayPrice', label: 'Wednesday', value: peopleWednedayPrice, setValue: setPeopleWednedayPrice},
    {key: 'peopleThurdayPrice', label: 'Thursday', value: peopleThurdayPrice, setValue: setPeopleThurdayPrice},
    {key: 'peopleFridayPrice', label: 'Friday', value: peopleFridayPrice, setValue: setPeopleFridayPrice},
    {key: 'peopleSaturdayPrice', label: 'Saturday', value: peopleSaturdayPrice, setValue: setPeopleSaturdayPrice},
    {key: 'peopleSundayPrice', label: 'Sunday', value: peopleSundayPrice, setValue: setPeopleSundayPrice},
  ]

  const validateSpecialPrice = () => {
    let isValid = true
    const errorTmp = [...validationErrors]

    if (primaryLanguage === 'English') {
      if (!en_title.trim()) {
        errorTmp[0].en_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(en_title.trim())) {
        errorTmp[0].en_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    } else if (primaryLanguage === 'Russian') {
      if (!ru_title.trim()) {
        errorTmp[0].ru_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(ru_title.trim())) {
        errorTmp[0].ru_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    } else if (primaryLanguage === 'Uzbek') {
      if (!uz_title.trim()) {
        errorTmp[0].uz_title = t('Title Is Required')
        isValid = false
      } else if (!hasSpecialCharacters(uz_title.trim())) {
        errorTmp[0].uz_title = t('Special Characters Are Not Allowed')
        isValid = false
      }
    }

    if (!fromDate && fromDate != '0') {
      errorTmp[0].fromDate = t('Start Date Is Required.')
      isValid = false
    }
    if (!toDate && toDate != '0') {
      errorTmp[0].toDate = t('End Date Is Required.')
      isValid = false
    }
    if (toDate != '' && fromDate != '' && toDate < fromDate) {
      errorTmp[0].toDate = t("End Date Can't Be Smaller Than Start Date.")
      isValid = false
    }
    if (moment(fromDate).isBefore(moment().startOf('day'))) {
      errorTmp[0].fromDate = t("Start Date Can't Be In The Past.")
      isValid = false
    }
    const requiredSpecialDays = isHourlySpecialPriceRequired
      ? [...hourlySpecialDays, ...peopleSpecialDays]
      : peopleSpecialDays
    requiredSpecialDays.forEach((day) => {
      if (!day.value && day.value != '0') {
        (errorTmp[0] as any)[day.key] = t('Price Is Required.')
        isValid = false
      }
    })

    setValidationErrors(errorTmp)
    return isValid
  }
  const handleSave = () => {
    if (!validateSpecialPrice()) {
      return
    }
    if (!checkDateConflict()) {
      return
    }
    const newData = {
      fromDate,
      toDate,
      en_title,
      ru_title,
      uz_title,
      hourlyType,
      peopleType,
      hourlyMondayPrice: hourlyMondayPrice || '0',
      hourlyTuesdayPrice: hourlyTuesdayPrice || '0',
      hourlyWednedayPrice: hourlyWednedayPrice || '0',
      hourlyThurdayPrice: hourlyThurdayPrice || '0',
      hourlyFridayPrice: hourlyFridayPrice || '0',
      hourlySaturdayPrice: hourlySaturdayPrice || '0',
      hourlySundayPrice: hourlySundayPrice || '0',
      peopleMondayPrice,
      peopleTuesdayPrice,
      peopleWednedayPrice,
      peopleThurdayPrice,
      peopleFridayPrice,
      peopleSaturdayPrice,
      peopleSundayPrice,
    }

    if (editIndex > -1) {
      const updatedData = specialPrice.map((item: any, index: any) =>
        index === editIndex ? newData : item
      )
      setSpecialPrice(updatedData)
      setEditIndex(-1)
    } else {
      setSpecialPrice([...specialPrice, newData])
    }

    resetForm()
  }

  const handleEdit = (index: any) => {
    const item = specialPrice[index]
    setFromDate(item.fromDate)
    setToDate(item.toDate)
    setEn_title(item.en_title)
    setRu_title(item.ru_title)
    setUz_title(item.uz_title)
    setHourlyType(item.hourlyType)
    setPeopleType(item.peopleType)
    setHourlyMondayPrice(item.hourlyMondayPrice)
    setHourlyTuesdayPrice(item.hourlyTuesdayPrice)
    setHourlyWednesdayPrice(item.hourlyWednedayPrice)
    setHourlyThursdayPrice(item.hourlyThurdayPrice)
    setHourlyFridayPrice(item.hourlyFridayPrice)
    setHourlySaturdayPrice(item.hourlySaturdayPrice)
    setHourlySundayPrice(item.hourlySundayPrice)
    setPeopleMondayPrice(item.peopleMondayPrice)
    setPeopleTuesdayPrice(item.peopleTuesdayPrice)
    setPeopleWednedayPrice(item.peopleWednedayPrice)
    setPeopleThurdayPrice(item.peopleThurdayPrice)
    setPeopleFridayPrice(item.peopleFridayPrice)
    setPeopleSaturdayPrice(item.peopleSaturdayPrice)
    setPeopleSundayPrice(item.peopleSundayPrice)
    setEditIndex(index)
  }

  const handleRemove = (index: any) => {
    setSpecialPrice(specialPrice.filter((_: any, i: any) => i !== index))
    resetForm()
  }

  const resetForm = () => {
    setFromDate('')
    setToDate('')
    setEn_title('')
    setRu_title('')
    setUz_title('')
    setHourlyType('Hourly')
    setPeopleType('People')
    setHourlyMondayPrice('0')
    setHourlyTuesdayPrice('0')
    setHourlyWednesdayPrice('0')
    setHourlyThursdayPrice('0')
    setHourlyFridayPrice('0')
    setHourlySaturdayPrice('0')
    setHourlySundayPrice('0')
    setPeopleMondayPrice('0')
    setPeopleTuesdayPrice('0')
    setPeopleWednedayPrice('0')
    setPeopleThurdayPrice('0')
    setPeopleFridayPrice('0')
    setPeopleSaturdayPrice('0')
    setPeopleSundayPrice('0')
    setEditIndex(-1)
  }
  const fileTypes = ['JPEG', 'JPG', 'PNG']

  const handleImageChange = async (e: any) => {
    removeError('inputImage')
    const selectedFiles = Array.from(e.target.files)
    const validFiles = selectedFiles.filter((file: any) => {
      if (file.size > 5 * 1024 * 1024) {
        // 5 MB = 5 * 1024 * 1024 bytes
        toasterrormsg(`${file.name} ${t('is larger than 5 MB and was not added.')}`)
        return false
      }
      return true
    })
    const MAX_IMAGES = 15
    // Check if adding selected files will exceed the limit
    if (inputImage.length + validFiles.length > MAX_IMAGES) {
      // If it exceeds, only select files up to the limit
      const remainingCapacity = MAX_IMAGES - inputImage.length
      const limitedFiles = validFiles.slice(0, remainingCapacity)

      // Display a message or perform an action to notify the user about the limit
      toasterrormsg(t(`Maximum ${MAX_IMAGES} images can be uploaded.`))

      // Compress the images
      const processedFiles = await Promise.all(limitedFiles.map((file: any) => processImage(file)))

      // Store the processed file names as paths
      const filePaths = processedFiles.map((file) => file)

      // Append new images to the existing array of images
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    } else {
      // If it doesn't exceed, proceed as before
      const processedFiles = await Promise.all(validFiles.map((file: any) => processImage(file)))
      const filePaths = processedFiles.map((file) => file)
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    }
  }

  const processImage = async (imageFile: File) => {
    if (imageFile.size >= 2 * 1024 * 1024) {
      return await compressImage(imageFile)
    } else {
      return imageFile
    }
  }

  const compressImage = async (imageFile: File) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    }
    try {
      const compressedBlob = await imageCompression(imageFile, options)
      const extension = imageFile.name.split('.').pop()
      const newFileName = `${Date.now()}.${extension}`
      const compressedFile = new File([compressedBlob], newFileName, {
        type: compressedBlob.type,
        lastModified: Date.now(),
      })
      return compressedFile
    } catch (error) {
      console.error('Error compressing image:', error)
      return imageFile
    }
  }

  // function for remove selected images
  const handleRemove1 = (index1: any) => {
    let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)

    setInputImage(tmparrimg)
  }

  // remove uplaoded images
  const handleRemoveImage = async (index: any) => {
    var param = {
      spacerentalmediaId: index,
    }
    var res = await fetchData('public/deleteSpaceRentalMedia', param)

    if (res.status == '200') {
      spacerentalDetailsApiCall()
    } else {
      toasterrormsg(res.message)
    }
  }

  const handleTextClick = () => {
    let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement
    element.click()
  }

  // validation function
  const basicInfoValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        rentableSpaceNameEN.trim() == '' ||
        rentableSpaceNameEN.trim() == null ||
        rentableSpaceNameEN.trim() == undefined
      ) {
        errorTmp[0].rentableSpaceNameEN = t('Rentable Space Name Is Required')
        isValid = false
      } else if (rentableSpaceNameEN.trim().length > 100) {
        errorTmp[0].rentableSpaceNameEN = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameRU.trim().length > 100) {
        errorTmp[0].rentableSpaceNameRU = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameUZ.trim().length > 100) {
        errorTmp[0].rentableSpaceNameUZ = t('Maximum 100 Characters Allowed')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        rentableSpaceNameRU.trim() == '' ||
        rentableSpaceNameRU.trim() == null ||
        rentableSpaceNameRU.trim() == undefined
      ) {
        errorTmp[0].rentableSpaceNameRU = t('Rentable Space Name Is Required')
        isValid = false
      } else if (rentableSpaceNameRU.trim().length > 100) {
        errorTmp[0].rentableSpaceNameRU = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameEN.trim().length > 100) {
        errorTmp[0].rentableSpaceNameEN = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameUZ.trim().length > 100) {
        errorTmp[0].rentableSpaceNameUZ = t('Maximum 100 Characters Allowed')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        rentableSpaceNameUZ.trim() == '' ||
        rentableSpaceNameUZ.trim() == null ||
        rentableSpaceNameUZ.trim() == undefined
      ) {
        errorTmp[0].rentableSpaceNameUZ = t('Rentable Space Name Is Required')
        isValid = false
      } else if (rentableSpaceNameUZ.trim().length > 100) {
        errorTmp[0].rentableSpaceNameUZ = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameEN.trim().length > 100) {
        errorTmp[0].rentableSpaceNameEN = t('Maximum 100 Characters Allowed')
        isValid = false
      }
      if (rentableSpaceNameRU.trim().length > 100) {
        errorTmp[0].rentableSpaceNameRU = t('Maximum 100 Characters Allowed')
        isValid = false
      }
    }
    if (maxPeople == '' || maxPeople == null || maxPeople == undefined) {
      errorTmp[0].maxPeople = t('Max People Is Required')
      isValid = false
    } else if (parseInt(maxPeople) <= 0) {
      errorTmp[0].maxPeople = t('Max People Must Be Greater Than 0')
      isValid = false
    } else if (parseFloat(maxPeople) >= 10000) {
      errorTmp[0].maxPeople = t('Max People Must Be Less Than 10,000')
      isValid = false
    } else if (parseInt(maxPeople) < parseInt(standardPeople)) {
      errorTmp[0].maxPeople = t('Max People Must Be Greater Than Or Equal To Standard People')
      isValid = false
    }
    if (standardPeople == '' || standardPeople == null || standardPeople == undefined) {
      errorTmp[0].standardPeople = t('Standard People Is Required')
      isValid = false
    } else if (!isOnlyNumber(standardPeople)) {
      errorTmp[0].standardPeople = t('Only Number Is Allowed')
      isValid = false
    }
    setError(errorTmp)
    return isValid
  }
  const generalInfoValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        generalInformationEN == '' ||
        generalInformationEN == null ||
        generalInformationEN == undefined
      ) {
        errorTmp[0].generalInformationEN = t('General Information Is Required')
        isValid = false
      }
      if (
        spaceInformationEN == '' ||
        spaceInformationEN == null ||
        spaceInformationEN == undefined
      ) {
        errorTmp[0].spaceInformationEN = t('Space Information Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        generalInformationRU == '' ||
        generalInformationRU == null ||
        generalInformationRU == undefined
      ) {
        errorTmp[0].generalInformationRU = t('General Information Is Required')
        isValid = false
      }
      if (
        spaceInformationRU == '' ||
        spaceInformationRU == null ||
        spaceInformationRU == undefined
      ) {
        errorTmp[0].spaceInformationRU = t('Space Information Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        generalInformationUZ == '' ||
        generalInformationUZ == null ||
        generalInformationUZ == undefined
      ) {
        errorTmp[0].generalInformationUZ = t('General Information Is Required')
        isValid = false
      }
      if (
        spaceInformationUZ == '' ||
        spaceInformationUZ == null ||
        spaceInformationUZ == undefined
      ) {
        errorTmp[0].spaceInformationUZ = t('Space Information Is Required')
        isValid = false
      }
    }
    setError(errorTmp)
    return isValid
  }
  const facilityAndServicesValidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (amenitiesSelectedOptions.length == 0) {
      errorTmp[0].amenityId = t('Rentable Space Amenities Is Required')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }
  const pricingAndAvailability = () => {
    var isValid = true
    var errorTmp = [...error]

    if (availableSpace == '') {
      errorTmp[0].availableSpace = t('Available Space Is Required')
      isValid = false
    } else if (!isOnlyNumber(availableSpace)) {
      errorTmp[0].availableSpace = t('Only Number Is Allowed')
      isValid = false
    }
    if (byDay == true) {
      if (baseCharge == '' || baseCharge == null || baseCharge == undefined) {
        errorTmp[0].baseCharge = t('Rentable Space Price Is Required')
        isValid = false
      } else if (!isOnlyNumber(baseCharge)) {
        errorTmp[0].baseCharge = t('Only Number Is Allowed')
        isValid = false
      }
      if (
        minimumNumberOfPeople == '' ||
        minimumNumberOfPeople == null ||
        minimumNumberOfPeople == undefined
      ) {
        errorTmp[0].minimumNumberOfPeople = t('Minimum Number Of People Is Required')
        isValid = false
      } else if (!isOnlyNumber(minimumNumberOfPeople)) {
        errorTmp[0].minimumNumberOfPeople = t('Only Number Is Allowed')
        isValid = false
      } else if (parseFloat(minimumNumberOfPeople) <= 0) {
        errorTmp[0].minimumNumberOfPeople = t('Values Must Be Greater Then 0')
        isValid = false
      }
    }
    if (byHours == true) {
      if (baseChargeByHours == '' || baseChargeByHours == null || baseChargeByHours == undefined) {
        errorTmp[0].baseChargeByHours = t('Rentable Space Price Is Required')
        isValid = false
      } else if (!isOnlyNumber(baseChargeByHours)) {
        errorTmp[0].baseChargeByHours = t('Only Number Is Allowed')
        isValid = false
      }
      if (
        minimumHoursForReservation == '' ||
        minimumHoursForReservation == null ||
        minimumHoursForReservation == undefined
      ) {
        errorTmp[0].minimumHoursForReservation = t('Minimum Hours For Reservation Is Required')
        isValid = false
      } else if (!isOnlyNumber(minimumHoursForReservation)) {
        errorTmp[0].minimumHoursForReservation = t('Only Number Is Allowed')
        isValid = false
      } else if (parseFloat(minimumHoursForReservation) <= 0) {
        errorTmp[0].minimumHoursForReservation = t('Values Must Be Greater Then 0')
        isValid = false
      }
    }
    if (!isOnlyNumber(extraPeopleCharge)) {
      errorTmp[0].extraPeopleCharge = t('Only Number Is Allowed')
      isValid = false
    }
    if (byDay == false && byHours == false) {
      errorTmp[0].bookingType = t('Booking Type Is Required')
      isValid = false
    }
    // Everything above is filled on the Regular Price sub-tab, so tell the user when its errors are not visible
    setPriceStepError(
      !isValid && priceTab !== 'RegularPrice'
        ? t('There is a mistake in filling details at Regular Price stage, please check and fix first.')
        : ''
    )
    if (events.length == 0) {
      errorTmp[0].availableDate = t('Please Select Available Date')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }
  const rentableSpacePhotosvalidate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (uploadedImage.length < 2) {
      if (inputImage.length == 0) {
        errorTmp[0].inputImage = t('Rentable Space Images Is Required')
        isValid = false
      } else if (inputImage.length < 2) {
        errorTmp[0].inputImage = t('Minimum 3 Images Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const additionalOptionsvalidate = () => {
    let isValid = true
    const newErrors = [...errors]

    additionalFields.forEach((field: any, index: any) => {
      if (!newErrors[index]) {
        newErrors[index] = {} as any
      }

      // Validate Space Name based on primary language
      if (primaryLanguage === 'English') {
        // if (!field.en_name || !field.en_name.trim()) {
        //   newErrors[index].en_name = t('Option Name Is Required');
        //   isValid = false;
        // } else
        if (!hasSpecialCharacters(field.en_name.trim())) {
          newErrors[0].en_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.en_name.trim().length > 100) {
          newErrors[index].en_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.ru_name.trim())) {
          newErrors[0].ru_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.ru_name.trim().length > 100) {
          newErrors[index].ru_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.uz_name.trim())) {
          newErrors[0].uz_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.uz_name.trim().length > 100) {
          newErrors[index].uz_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        // if (!field.en_description || !field.en_description.trim()) {
        //   newErrors[index].en_description = t('Option Description Is Required');
        //   isValid = false;
        // }
      } else if (primaryLanguage === 'Russian') {
        // if (!field.ru_name || !field.ru_name.trim()) {
        //   newErrors[index].ru_name = t('Option Name Is Required');
        //   isValid = false;
        // } else
        if (!hasSpecialCharacters(field.ru_name.trim())) {
          newErrors[0].ru_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.ru_name.trim().length > 100) {
          newErrors[index].ru_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.en_name.trim())) {
          newErrors[0].en_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.en_name.trim().length > 100) {
          newErrors[index].en_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.uz_name.trim())) {
          newErrors[0].uz_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.uz_name.trim().length > 100) {
          newErrors[index].uz_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        // if (!field.ru_description || !field.ru_description.trim()) {
        //   newErrors[index].ru_description = t('Option Description Is Required');
        //   isValid = false;
        // }
      } else if (primaryLanguage === 'Uzbek') {
        // if (!field.uz_name || !field.uz_name.trim()) {
        //   newErrors[index].uz_name = t('Option Name Is Required');
        //   isValid = false;
        // } else
        if (!hasSpecialCharacters(field.uz_name.trim())) {
          newErrors[0].uz_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.uz_name.trim().length > 100) {
          newErrors[index].uz_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.en_name.trim())) {
          newErrors[0].en_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.en_name.trim().length > 100) {
          newErrors[index].en_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        if (!hasSpecialCharacters(field.ru_name.trim())) {
          newErrors[0].ru_name = t('Special Characters Is Not Allow')
          isValid = false
        } else if (field.ru_name.trim().length > 100) {
          newErrors[index].ru_name = t('Maximum 100 Characters Allowed')
          isValid = false
        }
        // if (!field.uz_description || !field.uz_description.trim()) {
        //   newErrors[index].uz_description = t('Option Description Is Required');
        //   isValid = false;
        // }
      }

      // Validate Max Use Capacity
      // if (!field.maxUseCapacity || !field.maxUseCapacity.trim()) {
      //   newErrors[index].maxUseCapacity = t('Max Use Capacity Is Required');
      //   isValid = false;
      // } else
      if (!isOnlyNumber(field.maxUseCapacity)) {
        newErrors[index].maxUseCapacity = t('Only Number Is Allowed')
        isValid = false
      }

      // Validate Option Price
      // if (!field.spacePrice || !field.spacePrice.toString().trim()) {
      //   newErrors[index].spacePrice = t('Option Price Is Required');
      //   isValid = false;
      // }

      // Validate Image
      // if (!field.additionalImage) {
      //   newErrors[index].additionalImage = t('Space Image Is Required');
      //   isValid = false;
      // }
    })

    setErrors(newErrors)
    return isValid
  }

  const handleTabChange = (nextTab: any) => {
    let isValid = true

    if (isNextTab(nextTab)) {
      switch (tab) {
        case 'BasicInfo':
          isValid = basicInfoValidate()
          break
        case 'GeneralInfo':
          isValid = generalInfoValidate()
          break
        case 'FacilityAndServices':
          isValid = facilityAndServicesValidate()
          break
        case 'PricingAndAvailability':
          isValid = pricingAndAvailability()
          break
        case 'RentableSpacePhotos':
          isValid = rentableSpacePhotosvalidate()
          break
        case 'AdditionalOptions':
          isValid = additionalOptionsvalidate()
          break
        default:
          break
      }
    }

    if (isValid) {
      setTab(nextTab)
    }
  }

  const isNextTab = (nextTab: any) => {
    const tabOrder = [
      'BasicInfo',
      'GeneralInfo',
      'FacilityAndServices',
      'PricingAndAvailability',
      'RentableSpacePhotos',
      'AdditionalOptions',
    ]
    return tabOrder.indexOf(nextTab) > tabOrder.indexOf(tab)
  }

  const nextToGeneralInfo = () => {
    handleTabChange('GeneralInfo')
  }

  const nextToFacilityAndServices = () => {
    handleTabChange('FacilityAndServices')
  }

  const nextToPricingAndAvailability = () => {
    handleTabChange('PricingAndAvailability')
  }

  const nextToRentableSpacePhotos = () => {
    handleTabChange('RentableSpacePhotos')
  }

  const nextToAdditionalOptions = () => {
    handleTabChange('AdditionalOptions')
  }

  // ------------------- for schedule calander -------------------------
  const localizer = momentLocalizer(moment)

  interface CustomEvent {
    start: Date
    end: Date
    title: string
    type: 'available' | 'unavailable'
  }
  const [events, setEvents] = useState<CustomEvent[]>([])

  const [unAvailableEvents, setUnAvailableEvents] = useState<CustomEvent[]>([])

  // Function to generate default events from today to one year ahead, ensuring UTC time zone
  const generateDefaultEvents = (unavailableEvents: CustomEvent[]) => {
    const defaultEvents: CustomEvent[] = []

    // Force UTC start and end
    const startDate = moment.utc().startOf('day') // Start at UTC midnight
    const endDate = moment.utc().add(2, 'year').endOf('day') // End at UTC midnight of 2 years later

    // Iterate through days, setting each event to UTC midnight
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      const eventDate = date.clone().toDate() // Convert to JS Date in UTC

      // Check for existing unavailable events and create the appropriate event
      if (unavailableEvents.some((event) => moment.utc(event.start).isSame(date, 'day'))) {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: t('Unavailable'),
          type: 'unavailable',
        })
      } else {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: t('Available'),
          type: 'available',
        })
      }
    }
    return defaultEvents
  }

  // Use effect to synchronize unavailable events with the events state
  useEffect(() => {
    const updatedEvents = generateDefaultEvents(unAvailableEvents)
    setEvents(updatedEvents)
  }, [unAvailableEvents])

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t('Please Select Availability Type (available/unavailable).'))
      return
    }

    const selectedDates: Date[] = []

    // Convert both start and end to UTC with 12 AM time
    const startOfRange = moment.utc(slotInfo.start).startOf('day').add(1, 'days') // Start of day in UTC
    const endOfRange = moment.utc(slotInfo.end).startOf('day') // End of day in UTC

    // Loop through dates and select them in UTC
    for (let date = startOfRange.clone(); date.isSameOrBefore(endOfRange); date.add(1, 'day')) {
      selectedDates.push(date.toDate())
    }

    updateEvents(selectedDates)
  }

  const updateEvents = (selectedDates: Date[]) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t('Please Select Availability Types'))
      return
    }

    const newEvents: CustomEvent[] = []
    const eventsToRemove: CustomEvent[] = []

    selectedDates.forEach((selectedDate) => {
      const selectedMoment = moment.utc(selectedDate).startOf('day') // Set to UTC midnight
      const existingEventIndex = events.findIndex((event) =>
        moment.utc(event.start).isSame(selectedMoment, 'day')
      )

      if (existingEventIndex !== -1) {
        eventsToRemove.push(events[existingEventIndex])
      }

      const newEvent: CustomEvent = {
        start: selectedMoment.toDate(),
        end: selectedMoment.toDate(),
        title:
          availableTypeSelectedOptions.value!.charAt(0).toUpperCase() +
          availableTypeSelectedOptions.value!.slice(1),
        type: availableTypeSelectedOptions.value!,
      }
      newEvents.push(newEvent)
    })

    const updatedEvents = events.filter(
      (existingEvent) =>
        !eventsToRemove.some((removeEvent) =>
          moment.utc(existingEvent.start).isSame(moment.utc(removeEvent.start), 'day')
        )
    )

    setEvents([...updatedEvents, ...newEvents])

    // Update unavailable events
    if (availableTypeSelectedOptions.value === 'unavailable') {
      const newUnavailableEvents = newEvents.filter((event) => event.type === 'unavailable')
      setUnAvailableEvents([...unAvailableEvents, ...newUnavailableEvents])
    } else {
      const remainingUnavailableEvents = unAvailableEvents.filter(
        (event) =>
          !newEvents.some((ne) => moment.utc(ne.start).isSame(moment.utc(event.start), 'day'))
      )
      setUnAvailableEvents(remainingUnavailableEvents)
    }
  }

  // Apply available dates with UTC time zone
  const ApplyAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'))
      return
    }

    const startDate = moment.utc(startAvailableDate).startOf('day') // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day') // Convert end date to UTC midnight
    const today = moment.utc().startOf('day') // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'))
      return
    }

    const selectedDates: Date[] = []

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate())
    }

    updateEvents(selectedDates)
  }

  // Clear available dates with UTC time zone
  const clearAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'))
      return
    }

    const startDate = moment.utc(startAvailableDate).startOf('day') // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day') // Convert end date to UTC midnight
    const today = moment.utc().startOf('day') // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'))
      return
    }

    const selectedDates: Date[] = []

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate())
    }

    const updatedEvents: CustomEvent[] = events.map((event) => {
      const eventDate = moment.utc(event.start).startOf('day') // Convert event date to UTC
      if (
        event.type === 'unavailable' &&
        selectedDates.some((date) => moment.utc(date).isSame(eventDate, 'day'))
      ) {
        return {
          ...event,
          title: t('Available'),
          type: 'available',
        }
      }
      return event
    })

    setEvents(updatedEvents)

    // Remove the corresponding events from unAvailableEvents
    const updatedUnavailableEvents = unAvailableEvents.filter((event) => {
      const eventDate = moment.utc(event.start).startOf('day') // Convert event date to UTC
      return !selectedDates.some((date) => moment.utc(date).isSame(eventDate, 'day'))
    })

    setUnAvailableEvents(updatedUnavailableEvents)
  }

  const handleRemoveEvent = (event: CustomEvent) => {
    const updatedEvents = events.filter(
      (existingEvent) =>
        !(
          existingEvent.start === event.start &&
          existingEvent.end === event.end &&
          existingEvent.title === event.title &&
          existingEvent.type === event.type
        )
    )
    setEvents(updatedEvents)

    // Remove from unavailable events if applicable
    if (event.type === 'unavailable') {
      const updatedUnavailableEvents = unAvailableEvents.filter(
        (unavailableEvent) =>
          !(
            unavailableEvent.start === event.start &&
            unavailableEvent.end === event.end &&
            unavailableEvent.title === event.title &&
            unavailableEvent.type === event.type
          )
      )
      setUnAvailableEvents(updatedUnavailableEvents)
    }
  }

  const eventStyleGetter: CalendarProps<CustomEvent>['eventPropGetter'] = (
    event,
    start,
    end,
    isSelected
  ) => {
    const backgroundColor = event.type === 'available' ? 'green' : 'red'
    const style = {
      backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block',
    }
    return {
      style,
    }
  }
  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const spacerentalDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData('public/spaceDetails', param)

    if (response.status == '200') {
      var rentableSpaceList = response.data[0]['rentablespace']
      setSpaceDetails(rentableSpaceList)
      setSpaceDetail(response.data)
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = rentableSpaceList.slice(offset, offset + limit)

      setDisplayRentableSpaceList(tmp)
      var totpag = Math.ceil(rentableSpaceList.length / limit)
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = rentableSpaceList.length % limit
        if (mod > 0) {
          setTo(mod)
        } else {
          setTo(tmp.length)
        }
      } else {
        var mod = rentableSpaceList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        } else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)

      if (editRentableSpaceId != '') {
        var rentableSpace = rentableSpaceList.find(
          (value: any) => value['rentablespaceId'] === editRentableSpaceId
        )

        setRentableSpaceNameEN(rentableSpace['en_name'])
        setRentableSpaceNameRU(rentableSpace['ru_name'])
        setRentableSpaceNameUZ(rentableSpace['uz_name'])
        setSpaceInformationEN(rentableSpace['en_spaceInformation'])
        setSpaceInformationRU(rentableSpace['ru_spaceInformation'])
        setSpaceInformationUZ(rentableSpace['uz_spaceInformation'])
        setGeneralInformationEN(rentableSpace['en_generalInformation'])
        setGeneralInformationRU(rentableSpace['ru_generalInformation'])
        setGeneralInformationUZ(rentableSpace['uz_generalInformation'])
        setMaxPeople(rentableSpace['maxPeople'] + '')
        setIsSmokingAllowed(rentableSpace['isSmokingAllowed'])

        var amenities: any = []
        rentableSpace['amenity'].map((val: any) => {
          amenities.push({value: val.amenityId, label: getTranslatedValue(lang, val, '_name')})
        })
        setAmenitiesSelectedOptions(amenities)

        setByDay(rentableSpace['bookByDay'] == '1' ? true : false)
        setByHours(rentableSpace['bookByTime'] == '1' ? true : false)
        setUnAvailableEvents(rentableSpace['availableDate'])

        setBaseCharge(rentableSpace['baseCharge'] + '')
        setBaseChargeByHours(rentableSpace['baseChargeByHours'] + '')
        setMinimumNumberOfPeople(rentableSpace['minPeople'])
        setMinimumHoursForReservation(rentableSpace['minHour'])
        setExtraPeopleCharge(rentableSpace['extraPeopleCharge'] + '')
        setAvailableSpace(rentableSpace['availablespace'] + '')
        setStandardPeople(rentableSpace['standardPeople'])
        setUploadedImage(rentableSpace['images'])
        if (rentableSpace['addtionalSpaceDetail'].length != 0) {
          setAdditionalFields(rentableSpace['addtionalSpaceDetail'])
        }
        if (rentableSpace['specialPriceDetail'].length > 0) {
          setSpecialPrice(rentableSpace['specialPriceDetail'])
        }
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  // amenity list api call
  const amenityListAPIcall = async () => {
    var param = {
      categoryId: '4',
    }
    var res = await fetchData('public/amenityList', param)

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.amenityId, label: getTranslatedValue(lang, val, '_name')})
      })
      setAmenitiesList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // add rentableSpace api call
  const addRentableSpaceApi = async () => {
    if (additionalOptionsvalidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('spacerentalId', editSpacerentalId)
      param.append('en_name', rentableSpaceNameEN)
      param.append('ru_name', rentableSpaceNameRU)
      param.append('uz_name', rentableSpaceNameUZ)
      param.append('standardPeople', standardPeople)
      param.append('maxPeople', maxPeople)
      param.append('en_generalInformation', generalInformationEN)
      param.append('ru_generalInformation', generalInformationRU)
      param.append('uz_generalInformation', generalInformationUZ)
      param.append('en_spaceInformation', spaceInformationEN)
      param.append('ru_spaceInformation', spaceInformationRU)
      param.append('uz_spaceInformation', spaceInformationUZ)
      param.append('amenityId', amenityId)
      param.append('isSmokingAllowed', isSmokingAllowed)
      param.append('availablespace', availableSpace)
      param.append('byDay', byDay ? '1' : '0')
      param.append('byHours', byHours ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (byDay == true) {
        param.append('baseCharge', baseCharge)
        param.append('minPeople', minimumNumberOfPeople)
      }
      if (byHours == true) {
        param.append('baseChargeByHours', baseChargeByHours)
        param.append('minHour', minimumHoursForReservation)
      }
      param.append('extraPeopleCharge', extraPeopleCharge)

      param.append('availableDate', JSON.stringify(unAvailableEvents))
      param.append('additionalrentalspace', JSON.stringify(additionalFields))

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file)
        })
      }

      var res = await fetchFormData('public/addRentableSpace', param)

      if (res.status == '200') {
        toastsuccessmsg(t('Rentable Space Added Successfully!'))
        spacerentalDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false)
      } else {
        setLoading(false)
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }
  //   delete hotel api call
  const confirmdelete = (rentablespaceId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          rentablespaceId: rentablespaceId,
        }
        var res = await fetchData('public/deleteRentableSpace', param)

        if (res.status == '200') {
          spacerentalDetailsApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }
  const editModalOpen = (rentablespaceId: any) => {
    setEditRentableSpaceId(rentablespaceId)
    handleShow()
  }
  useEffect(() => {
    spacerentalDetailsApiCall()
  }, [editRentableSpaceId])
  // edit rentableSpace api call
  const editRentableSpaceApi = async () => {
    if (additionalOptionsvalidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('spacerentalId', String(editSpacerentalId))
      param.append('rentablespaceId', editRentableSpaceId)
      param.append('en_name', rentableSpaceNameEN)
      param.append('ru_name', rentableSpaceNameRU)
      param.append('uz_name', rentableSpaceNameUZ)
      param.append('standardPeople', standardPeople)
      param.append('maxPeople', maxPeople)
      param.append('en_generalInformation', generalInformationEN)
      param.append('ru_generalInformation', generalInformationRU)
      param.append('uz_generalInformation', generalInformationUZ)
      param.append('en_spaceInformation', spaceInformationEN)
      param.append('ru_spaceInformation', spaceInformationRU)
      param.append('uz_spaceInformation', spaceInformationUZ)
      param.append('amenityId', amenityId)
      // param.append('viewId', viewId)
      param.append('isSmokingAllowed', isSmokingAllowed)
      param.append('availablespace', availableSpace)
      param.append('byDay', byDay ? '1' : '0')
      param.append('byHours', byHours ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (byDay == true) {
        param.append('baseCharge', baseCharge)
        param.append('minPeople', minimumNumberOfPeople)
      }
      if (byHours == true) {
        param.append('baseChargeByHours', baseChargeByHours)
        param.append('minHour', minimumHoursForReservation)
      }
      param.append('extraPeopleCharge', extraPeopleCharge)
      param.append('availableDate', JSON.stringify(unAvailableEvents))
      param.append('additionalrentalspace', JSON.stringify(additionalFields))

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file)
        })
      }

      var res = await fetchFormData('public/addRentableSpace', param)

      if (res.status == '200') {
        toastsuccessmsg(t('Rentable Space Updated Successfully!'))
        spacerentalDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false)
      } else {
        setLoading(false)
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
    setDisable(false)
  }

  useEffect(() => {
    amenityListAPIcall()
  }, [])

  const cleanStates = () => {
    setLoading(false)
    setRentableSpaceNameEN('')
    setRentableSpaceNameRU('')
    setRentableSpaceNameUZ('')
    setGeneralInformationEN('')
    setGeneralInformationRU('')
    setGeneralInformationUZ('')
    setMaxPeople('')
    setAmenitiesSelectedOptions([])
    setIsSmokingAllowed('No')
    setByDay(true)
    setByHours(true)
    setStartAvailableDate('')
    setEndAvailableDate('')
    setAvailableTypeSelectedOptions(undefined)
    setEvents([])
    setUnAvailableEvents([])
    setAdditionalFields([
      {
        en_name: '',
        ru_name: '',
        uz_name: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
        maxUseCapacity: '',
        spacePrice: '',
        additionalImage: null,
        thumbPath: '',
        image: '',
      },
    ])
    setTab('BasicInfo')
    setBaseCharge('')
    setBaseChargeByHours('')
    setExtraPeopleCharge('')
    setSpaceInformationEN('')
    setSpaceInformationRU('')
    setSpaceInformationUZ('')
    setAvailableSpace('')
    setStandardPeople('')
    setInputImage([])
    setUploadedImage([])
    resetForm()
    setPriceTab('RegularPrice')
    setSpecialPrice([])
    removeError('rentableSpaceNameEN')
    removeError('rentableSpaceNameRU')
    removeError('rentableSpaceNameUZ')
    removeError('generalInformationEN')
    removeError('generalInformationRU')
    removeError('generalInformationUZ')
    removeError('standardPeople')
    removeError('maxPeople')
    removeError('amenityId')
    removeError('viewId')
    removeError('availableSpace')
    removeError('baseCharge')
    removeError('bookingType')
    removeError('fromAvailableHours')
    removeError('toAvailableHours')
    removeError('availableDate')
    removeError('inputImage')
  }
  useEffect(() => {
    const modal = document.querySelector('.modal')
    if (modal) {
      modal.removeAttribute('tabindex')
    }
  }, [show])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Rentable Space')}</PageTitle>
      <ToastContainer />
      <AddSpaceHeader spacerentalId={editSpacerentalId} />
      <div className='d-flex flex-column'>
        {/* <!--begin::General options--> */}
        <div className='card card-flush py-4'>
          {/* <!--begin::Card header--> */}
          <div className='card-header d-flex'>
            {/* <!--begin::Card title--> */}
            <div className='card-title'>
              <h2>{t('Rentable Space Details')}</h2>
            </div>
            {/* <!--end::Card title--> */}
            <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
              {spaceDetail.length != 0 ? (
                <>
                  {spaceDetail.map((completedSteps: any, index: any) => {
                    var percentage = 0
                    if (completedSteps['completedSteps']['basicInfo']) {
                      percentage = 10
                    }
                    if (completedSteps['completedSteps']['location']) {
                      percentage = 20
                    }
                    if (completedSteps['completedSteps']['propertyDetail']) {
                      percentage = 40
                    }
                    if (completedSteps['completedSteps']['rentableSpace']) {
                      percentage = 50
                    }
                    if (completedSteps['completedSteps']['photos']) {
                      percentage = 60
                    }
                    if (completedSteps['completedSteps']['facilitiesAndServices']) {
                      percentage = 70
                    }
                    if (completedSteps['completedSteps']['availability']) {
                      percentage = 80
                    }
                    if (completedSteps['completedSteps']['policies']) {
                      percentage = 90
                    }
                    if (completedSteps['completedSteps']['financeAndLegal']) {
                      percentage = 100
                    }
                    return (
                      <React.Fragment key={index}>
                        <div className='d-flex justify-content-between w-100 mt-auto'>
                          <span className='fw-bold fs-6'>{t('Completion')}</span>
                          <span className='fw-bolder fs-6'>{percentage}%</span>
                        </div>
                        <div className='h-5px mx-3 w-100 bg-light mb-3'>
                          <div
                            className='bg-success rounded h-5px'
                            role='progressbar'
                            style={{width: `${percentage}%`}}
                          ></div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </>
              ) : (
                <>
                  <div className='d-flex justify-content-between w-100 mt-auto'>
                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                    <span className='fw-bolder fs-6'>0%</span>
                  </div>
                  <div className='h-5px mx-3 w-100 bg-light mb-3'>
                    <div
                      className='bg-success rounded h-5px'
                      role='progressbar'
                      style={{width: '0%'}}
                    ></div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* <!--end::Card header--> */}
          <div className='d-flex justify-content-end mx-10 mt-3'>
            <button
              className='btn text-white cursor-pointer btn-primary'
              id='kt_toolbar_primary_button'
              style={{color: 'rgb(24, 28, 50)'}}
              onClick={handleShow}
            >
              + {t('Add Rentable Space')}
            </button>
          </div>
        </div>
        {/* <!--end::Pricing--> */}
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {displayRentableSpaceList.map((space: any, index: any) => {
          var description = getTranslatedValue(lang, space, '_spaceInformation', primLanguage)
          var spaceName = getTranslatedValue(lang, space, '_name', primLanguage)
          return (
            <div className='col-xl-4' key={index}>
              <MixedWidget22
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                rentablespaceId={space['rentablespaceId']}
                deleteRentableSpace={confirmdelete}
                editModalOpen={editModalOpen}
                rentableSpaceName={spaceName}
                image={
                  space['images'].length != 0
                    ? space['images'][0].thumbPath
                    : toAbsoluteUrl('/media/logos/InsayrLogo.png')
                }
                description={description}
                availablespace={space['availablespace']}
                maxPeople={space['maxPeople']}
                progress='100%'
              />
            </div>
          )
        })}
      </div>
      {spaceDetails.length != 0 ? (
        <>
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>
              {t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(spaceDetails.length))}
            </div>

            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => onpagecahnge(page - 1)}
                >
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any, index: any) => {
                return (
                  <li
                    className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}
                    key={index}
                  >
                    <span className='page-link' onClick={() => onpagecahnge(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => (page + 1 <= totalPage ? onpagecahnge(page + 1) : '')}
                >
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
          <div className='row my-10'>
            <div className='col-lg-12 text-end'>
              <Link
                to={'../addspacephotos/'}
                state={{spacerentalId: editSpacerentalId}}
                className='btn btn-primary'
              >
                {t('Next')}
              </Link>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
      {/* end::Row */}
      <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{display: 'block'}}
          aria-modal='true'
          role='dialog'
        >
          {/* <!--begin::Modal dialog--> */}
          <div className='modal-dialog modal-dialog-centered mw-950px'>
            {/* <!--begin::Modal content--> */}
            <div className='modal-content'>
              {/* <!--begin::Form--> */}
              <div className='form' id='kt_modal_upload_form'>
                {/* <!--begin::Modal header--> */}
                <div className='modal-header d-flex justify-content-between'>
                  {/* <!--begin::Modal title--> */}
                  <h2 className='fw-bold'>
                    {' '}
                    {editRentableSpaceId != '' ? t('Edit Rentable Space') : t('Add Rentable Space')}
                  </h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleClose}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                <div className='card card-custom'>
                  <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                      className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                      role='tablist'
                    >
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'BasicInfo',
                          })}
                          onClick={() => setTab('BasicInfo')}
                          role='tab'
                        >
                          {t('Basic Info')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'GeneralInfo',
                          })}
                          onClick={nextToGeneralInfo}
                          role='tab'
                        >
                          {t('General Information')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'FacilityAndServices',
                          })}
                          onClick={nextToFacilityAndServices}
                          role='tab'
                        >
                          {t('Facility & Services')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'PricingAndAvailability',
                          })}
                          onClick={nextToPricingAndAvailability}
                          role='tab'
                        >
                          {t('Pricing & Availability')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'RentableSpacePhotos',
                          })}
                          onClick={nextToRentableSpacePhotos}
                          role='tab'
                        >
                          {t('Rentable Space Photos')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer text-nowrap`, {
                            active: tab === 'AdditionalOptions',
                          })}
                          onClick={nextToAdditionalOptions}
                          role='tab'
                        >
                          {t('Additional Options')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  {/* <!--begin::Input group--> */}
                  <div className='form-group'>
                    {/* <!--begin::Dropzone--> */}
                    <div className='dropzone dropzone-queue mb-2' id='kt_modal_upload_dropzone'>
                      {/* <!--begin::Controls--> */}
                      <div className='dropzone-panel mb-4'>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'BasicInfo'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Rentable Space Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameEN}
                                      onChange={(e) => {
                                        setRentableSpaceNameEN(e.target.value)
                                        removeError('rentableSpaceNameEN')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].rentableSpaceNameEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Rentable Space Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameRU}
                                      onChange={(e) => {
                                        setRentableSpaceNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Rentable Space Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameUZ}
                                      onChange={(e) => {
                                        setRentableSpaceNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Rentable Space Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameRU}
                                      onChange={(e) => {
                                        setRentableSpaceNameRU(e.target.value)
                                        removeError('rentableSpaceNameRU')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].rentableSpaceNameRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Rentable Space Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameEN}
                                      onChange={(e) => {
                                        setRentableSpaceNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Rentable Space Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameUZ}
                                      onChange={(e) => {
                                        setRentableSpaceNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Rentable Space Name (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameUZ}
                                      onChange={(e) => {
                                        setRentableSpaceNameUZ(e.target.value)
                                        removeError('rentableSpaceNameUZ')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].rentableSpaceNameUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Rentable Space Name (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameRU'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameRU}
                                      onChange={(e) => {
                                        setRentableSpaceNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('Rentable Space Name (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='rentableSpaceNameEN'
                                      className='form-control mb-2'
                                      placeholder={t('Rentable Space Name')}
                                      value={rentableSpaceNameEN}
                                      onChange={(e) => {
                                        setRentableSpaceNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('Standard People')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='standardPeople'
                                  className='form-control mb-2'
                                  placeholder={t('Standard People')}
                                  value={standardPeople}
                                  onChange={(e) => {
                                    setStandardPeople(e.target.value)
                                    removeError('standardPeople')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].standardPeople}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('Max People')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='maxPeople'
                                  className='form-control mb-2'
                                  placeholder={t('Max People')}
                                  value={maxPeople}
                                  onChange={(e) => {
                                    setMaxPeople(e.target.value)
                                    removeError('maxPeople')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].maxPeople}</div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={handleClose}
                                  >
                                    {t('Cancel')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToGeneralInfo}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'GeneralInfo'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Space Information (English)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationEN}
                                      onChange={(e) => {
                                        setSpaceInformationEN(e.target.value)
                                        removeError('spaceInformationEN')
                                      }}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].spaceInformationEN}
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (Russian)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationRU}
                                      onChange={(e) => setSpaceInformationRU(e.target.value)}
                                    ></textarea>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (Uzbek)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationUZ}
                                      onChange={(e) => setSpaceInformationUZ(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('General Information (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationEN}
                                      onBlur={(newContent) => {
                                        setGeneralInformationEN(newContent)
                                        removeError('generalInformationEN')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].generalInformationEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('General Information (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationRU}
                                      onBlur={(newContent) => {
                                        setGeneralInformationRU(newContent)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('General Information (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationUZ}
                                      onBlur={(newContent) => {
                                        setGeneralInformationUZ(newContent)
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Space Information (Russian)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationRU}
                                      onChange={(e) => {
                                        setSpaceInformationRU(e.target.value)
                                        removeError('spaceInformationRU')
                                      }}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].spaceInformationRU}
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (English)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationEN}
                                      onChange={(e) => setSpaceInformationEN(e.target.value)}
                                    ></textarea>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (Uzbek)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationUZ}
                                      onChange={(e) => setSpaceInformationUZ(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('General Information (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationRU}
                                      onBlur={(newContent) => {
                                        setGeneralInformationRU(newContent)
                                        removeError('generalInformationRU')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].generalInformationRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('General Information (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationEN}
                                      onBlur={(newContent) => {
                                        setGeneralInformationEN(newContent)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('General Information (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationUZ}
                                      onBlur={(newContent) => {
                                        setGeneralInformationUZ(newContent)
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Space Information (Uzbek)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationUZ}
                                      onChange={(e) => {
                                        setSpaceInformationUZ(e.target.value)
                                        removeError('spaceInformationUZ')
                                      }}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].spaceInformationUZ}
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (Russian)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationRU}
                                      onChange={(e) => setSpaceInformationRU(e.target.value)}
                                    ></textarea>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Space Information (English)')}
                                    </label>
                                    <textarea
                                      name='spaceInformationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Space Information')}
                                      cols={30}
                                      rows={4}
                                      value={spaceInformationEN}
                                      onChange={(e) => setSpaceInformationEN(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('General Information (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationUZ}
                                      onBlur={(newContent) => {
                                        setGeneralInformationUZ(newContent)
                                        removeError('generalInformationUZ')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].generalInformationUZ}
                                    </div>
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('General Information (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationRU}
                                      onBlur={(newContent) => {
                                        setGeneralInformationRU(newContent)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-5 form-label'>
                                      {t('General Information (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <JoditEditor
                                      ref={editorRef}
                                      config={config}
                                      value={generalInformationEN}
                                      onBlur={(newContent) => {
                                        setGeneralInformationEN(newContent)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('BasicInfo')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToFacilityAndServices}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div
                            className={clsx('tab-pane', {active: tab === 'FacilityAndServices'})}
                          >
                            <div className='row'>
                              <div className='col-lg-7 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('Facilities & Services')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='amenities[]'
                                  id='amenitiesListId'
                                  placeholder={t('Select Facilities & Services')}
                                  isSearchable={true}
                                  isMulti
                                  options={amenitiesList}
                                  value={amenitiesSelectedOptions}
                                  onChange={(e: any) => {
                                    setAmenitiesSelectedOptions(e)
                                    removeError('amenityId')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].amenityId}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                <div className='row'>
                                  {/* <!--begin::Label--> */}
                                  <label className='fs-4 form-label'>
                                    {t('Is smoking allowed in this studio?')}
                                  </label>
                                  {/* <!--end::Label--> */}
                                  <div className='col-4 my-2'>
                                    <label className='d-flex text-start' data-kt-button='true'>
                                      {/* <!--begin::Radio--> */}
                                      <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                        <input
                                          className='form-check-input'
                                          type='radio'
                                          name='isSmokingAllowed'
                                          value='Yes'
                                          checked={isSmokingAllowed == 'Yes'}
                                          onChange={(e: any) => {
                                            setIsSmokingAllowed(e.target.value)
                                          }}
                                        />
                                      </span>
                                      {/* <!--end::Radio--> */}
                                      {/* <!--begin::Info--> */}
                                      <span className='ms-5'>
                                        <span className='fs-4 fw-bold text-gray-800 d-block'>
                                          {t('Yes')}
                                        </span>
                                      </span>
                                      {/* <!--end::Info--> */}
                                    </label>
                                  </div>
                                  <div className='col-4 my-2'>
                                    <label className='d-flex text-start' data-kt-button='true'>
                                      {/* <!--begin::Radio--> */}
                                      <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                        <input
                                          className='form-check-input'
                                          type='radio'
                                          name='isSmokingAllowed'
                                          value='No'
                                          checked={isSmokingAllowed == 'No'}
                                          onChange={(e: any) => {
                                            setIsSmokingAllowed(e.target.value)
                                          }}
                                        />
                                      </span>
                                      {/* <!--end::Radio--> */}
                                      {/* <!--begin::Info--> */}
                                      <span className='ms-5'>
                                        <span className='fs-4 fw-bold text-gray-800 d-block'>
                                          {t('No')}
                                        </span>
                                      </span>
                                      {/* <!--end::Info--> */}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-1'></div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('GeneralInfo')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToPricingAndAvailability}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div
                            className={clsx('tab-pane', {active: tab === 'PricingAndAvailability'})}
                          >
                            <div className='card-header card-header-stretch overflow-auto'>
                              <ul
                                className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                                role='tablist'
                              >
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'RegularPrice',
                                    })}
                                    onClick={() => setPriceTab('RegularPrice')}
                                    role='tab'
                                  >
                                    {t('Regular Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'SpecialPrice',
                                    })}
                                    onClick={() => setPriceTab('SpecialPrice')}
                                    role='tab'
                                  >
                                    {t('Special Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, {
                                      active: priceTab === 'Availability',
                                    })}
                                    onClick={() => setPriceTab('Availability')}
                                    role='tab'
                                  >
                                    {t('Availability')}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'RegularPrice'})}
                              >
                                <div className='row'>
                                  <div className='col-lg-6 my-3'>
                                    <div className='row'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-4 form-label required'>
                                        {t('Booking Type')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      <div className='col-lg-5 col-5 my-2'>
                                        <label className='d-flex text-start' data-kt-button='true'>
                                          {/* <!--begin::Radio--> */}
                                          <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              name='byDay'
                                              value='true'
                                              checked={byDay}
                                              onChange={(e) => {
                                                handleByDayChange(e)
                                                removeError('bookingType')
                                              }}
                                            />
                                          </span>
                                          {/* <!--end::Radio--> */}
                                          {/* <!--begin::Info--> */}
                                          <span className='ms-5'>
                                            <span className='fs-4 fw-bold text-gray-800 d-block'>
                                              {t('By People')}
                                            </span>
                                          </span>
                                          {/* <!--end::Info--> */}
                                        </label>
                                      </div>
                                    </div>
                                    <div className='text-danger fw-bold'>
                                      {error[0].bookingType}
                                    </div>
                                  </div>
                                </div>
                                <div className='row'>
                                  {byDay && (
                                    <>
                                      <div className='col-lg-4 my-3'>
                                        <PriceInput
                                          labelClass='required fs-5 form-label'
                                          label={t('Rentable Space Price (Per Person)')}
                                          inputClass='form-control mb-2 border-right-0'
                                          placeholder={t('Rentable Space Price')}
                                          value={baseCharge}
                                          onChange={(e: any) => {
                                            setBaseCharge(e)
                                            removeError('baseCharge')
                                          }}
                                        />
                                        <div className='text-danger fw-bold'>
                                          {error[0].baseCharge}
                                        </div>
                                      </div>
                                      <div className='col-lg-4 my-3'>
                                        {/* <!--begin::Label--> */}
                                        <label className='required fs-5 form-label'>
                                          {t('Minimum Number Of People')}
                                        </label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input
                                          type='text'
                                          name='minimumNumberOfPeople'
                                          className='form-control mb-2'
                                          placeholder={t('Minimum Number Of People')}
                                          value={minimumNumberOfPeople}
                                          onChange={(e) => {
                                            setMinimumNumberOfPeople(e.target.value)
                                            removeError('minimumNumberOfPeople')
                                          }}
                                        />
                                        <div className='text-danger fw-bold'>
                                          {error[0].minimumNumberOfPeople}
                                        </div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div className='col-lg-4 col-5 my-2'>
                                  <label className='d-flex text-start' data-kt-button='true'>
                                    {/* <!--begin::Radio--> */}
                                    <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                      <input
                                        className='form-check-input'
                                        type='checkbox'
                                        name='byHours'
                                        value='true'
                                        checked={byHours}
                                        onChange={(e) => {
                                          handleByHoursChange(e)
                                          removeError('bookingType')
                                        }}
                                      />
                                    </span>
                                    {/* <!--end::Radio--> */}
                                    {/* <!--begin::Info--> */}
                                    <span className='ms-5'>
                                      <span className='fs-4 fw-bold text-gray-800 d-block'>
                                        {t('By Hours')}
                                      </span>
                                    </span>
                                    {/* <!--end::Info--> */}
                                  </label>
                                </div>
                                <div className='row'>
                                  {byHours && (
                                    <>
                                      <div className='col-lg-4 my-3'>
                                        <PriceInput
                                          labelClass='required fs-5 form-label'
                                          label={t('Rentable Space Price (By Hours)')}
                                          inputClass='form-control mb-2 border-right-0'
                                          placeholder={t('Rentable Space Price')}
                                          value={baseChargeByHours}
                                          onChange={(e: any) => {
                                            setBaseChargeByHours(e)
                                            removeError('baseChargeByHours')
                                          }}
                                        />
                                        <div className='text-danger fw-bold'>
                                          {error[0].baseChargeByHours}
                                        </div>
                                      </div>
                                      <div className='col-lg-4 my-3'>
                                        {/* <!--begin::Label--> */}
                                        <label className='required fs-5 form-label'>
                                          {t('Minimum Hours For Reservation')}
                                        </label>
                                        {/* <!--end::Label--> */}
                                        <input
                                          type='number'
                                          name='minimumHoursForReservation'
                                          className='form-control mb-2'
                                          placeholder={t('Minimum Hours For Reservation')}
                                          value={minimumHoursForReservation}
                                          onChange={(e) => {
                                            setMinimumHoursForReservation(e.target.value)
                                            removeError('minimumHoursForReservation')
                                          }}
                                        />
                                        <div className='text-danger fw-bold'>
                                          {error[0].minimumHoursForReservation}
                                        </div>
                                      </div>
                                      <div className='col-lg-4 my-3'>
                                        <PriceInput
                                          labelClass='fs-6 form-label'
                                          label={t('Charge per extra person')}
                                          inputClass='form-control mb-2 border-right-0'
                                          placeholder={t('Extra People Charge')}
                                          value={extraPeopleCharge}
                                          onChange={(e: any) => {
                                            setExtraPeopleCharge(e)
                                            removeError('extraPeopleCharge')
                                          }}
                                        />
                                        <div className='text-danger fw-bold'>
                                          {error[0].extraPeopleCharge}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-sm btn-primary me-4'
                                        onClick={() => setPriceTab('SpecialPrice')}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'SpecialPrice'})}
                              >
                                <div className='col-lg-12 d-flex gap-2 bg-light-warning p-3 border rounded border-warning'>
                                  {/* <span className='fs-3 text-gray-500 required'></span>{' '} */}
                                  <i className="fas fa-info-circle text-success fs-5 mt-1"></i>
                                  <label className='fs-7 text-gray-600 form-label'>
                                    {' '}
                                    {t(
                                      'Fill out this section only if you want to set “Special Prices” for your services. Otherwise, simply skip it. Special Prices are typically offered to customers during holidays and special days at your discretion.'
                                    )}
                                  </label>
                                </div>
                                <div className='row mt-5'>
                                  <div className='col-lg-12'>
                                    <label className='fs-4 fw-bolder form-label'>
                                      {t('Date Range')}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 required form-label'>{t('From')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={fromDate}
                                      onChange={([date]) => {
                                        setFromDate(date.toISOString())
                                        clearValidationError('fromDate')
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: 'Y-m-d H:i',
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].fromDate}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 required form-label'>{t('To')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={toDate}
                                      onChange={([date]) => {
                                        setToDate(date.toISOString())
                                        clearValidationError('toDate')
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: 'Y-m-d H:i',
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {validationErrors[0].toDate}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                {primaryLanguage == 'English' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                          clearValidationError('en_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].en_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                {primaryLanguage == 'Russian' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                          clearValidationError('ru_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].ru_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                {primaryLanguage == 'Uzbek' && (
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='required fs-5 form-label'>
                                        {t('Title (Uzbek)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='uz_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={uz_title}
                                        onChange={(e) => {
                                          setUz_title(e.target.value)
                                          clearValidationError('uz_title')
                                        }}
                                      />
                                      <div className='text-danger fw-bold'>
                                        {validationErrors[0].uz_title}
                                      </div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (Russian)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='ru_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={ru_title}
                                        onChange={(e) => {
                                          setRu_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      {/* <!--begin::Label--> */}
                                      <label className='fs-5 form-label'>
                                        {t('Title (English)')}
                                      </label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input
                                        type='text'
                                        name='en_title'
                                        className='form-control mb-2'
                                        placeholder={t('Title')}
                                        value={en_title}
                                        onChange={(e) => {
                                          setEn_title(e.target.value)
                                        }}
                                      />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                )}
                                <div className='row'>
                                  <div className='col-lg-6 border-end'>
                                    <SpecialPriceDays
                                      title='Hourly Type'
                                      days={hourlySpecialDays}
                                      required={isHourlySpecialPriceRequired}
                                      errors={validationErrors[0]}
                                      clearError={clearValidationError}
                                    />
                                  </div>
                                  <div className='col-lg-6'>
                                    <SpecialPriceDays
                                      title='People Type'
                                      days={peopleSpecialDays}
                                      errors={validationErrors[0]}
                                      clearError={clearValidationError}
                                    />
                                  </div>
                                  <div className='col-lg-12 d-flex justify-content-end align-items-end'>
                                    <button className='btn btn-primary mb-3' onClick={handleSave}>
                                      {editIndex > -1 ? t('Update') : t('Save')}
                                    </button>
                                  </div>
                                </div>
                                <div className='card'>
                                  {/* begin::Body */}
                                  <div className='card-body pt-5 p-0'>
                                    {/* begin::Table container */}
                                    <div className='table-responsive'>
                                      {/* begin::Table */}
                                      <table className='table align-middle gs-0 gy-4'>
                                        {/* begin::Table head */}
                                        <thead>
                                          <tr className='fw-bold text-muted bg-light'>
                                            <th className='ps-4 min-w-325px rounded-start'>
                                              {t('Date Range')}
                                            </th>
                                            <th className='min-w-150px'>{t('Title')}</th>
                                            <th className='min-w-150px'>{t('Type')}</th>
                                            <th className='min-w-150px'>{t('Mon')}</th>
                                            <th className='min-w-150px'>{t('Tue')}</th>
                                            <th className='min-w-150px'>{t('Wed')}</th>
                                            <th className='min-w-150px'>{t('Thu')}</th>
                                            <th className='min-w-150px'>{t('Fri')}</th>
                                            <th className='min-w-150px'>{t('Sat')}</th>
                                            <th className='min-w-150px'>{t('Sun')}</th>
                                            <th className='min-w-200px rounded-end'>
                                              {t('Action')}
                                            </th>
                                          </tr>
                                        </thead>
                                        {/* end::Table head */}
                                        {/* begin::Table body */}
                                        <tbody>
                                          {specialPrice.map((item: any, index: any) => {
                                            return (
                                              <tr className='border-bottom' key={index}>
                                                <td>
                                                  <div className='d-flex align-items-center'>
                                                    <div className='d-flex justify-content-start flex-column'>
                                                      <h6 className='fw-bold mb-1 fs-7'>
                                                        {formatDate(item.fromDate)} to{' '}
                                                        {formatDate(item.toDate)}
                                                      </h6>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {getTranslatedValue(
                                                      lang,
                                                      item,
                                                      '_title',
                                                      primaryLanguage
                                                    )}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {t(item.hourlyType)}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {t(item.peopleType)}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlyMondayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleMondayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlyTuesdayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleTuesdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlyWednedayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleWednedayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlyThurdayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleThurdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlyFridayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleFridayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlySaturdayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleSaturdayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.hourlySundayPrice}
                                                  </h6>
                                                  <h6 className='fw-bold d-block mb-1 fs-7'>
                                                    {item.peopleSundayPrice}
                                                  </h6>
                                                </td>
                                                <td>
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                    onClick={() => handleEdit(index)}
                                                  >
                                                    <KTIcon iconName='pencil' className='fs-3' />
                                                  </button>
                                                  <button
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                    onClick={() => handleRemove(index)}
                                                  >
                                                    <KTIcon iconName='trash' className='fs-3' />
                                                  </button>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                        {/* end::Table body */}
                                      </table>
                                      {specialPrice.length == 0 && (
                                        <div className='row'>
                                          <div className='col-lg-12 text-center'>
                                            <label className='fs-6 text-gray-500 my-5 text-center'>
                                              {t('No Records Found.')}
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                      {/* end::Table */}
                                    </div>
                                    {/* end::Table container */}
                                  </div>
                                  {/* begin::Body */}
                                </div>
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                       <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setPriceTab('RegularPrice')}
                                  >
                                    {t('Back')}
                                  </button>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-sm btn-primary me-4'
                                        onClick={() => setPriceTab('Availability')}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='tab-content pt-3'>
                              <div
                                className={clsx('tab-pane', {active: priceTab === 'Availability'})}
                              >
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-5 form-label'>
                                      {t('Available space of the same type')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='availableSpace'
                                      className='form-control mb-2'
                                      placeholder={t('Available Space')}
                                      value={availableSpace}
                                      onChange={(e) => {
                                        setAvailableSpace(e.target.value)
                                        removeError('availableSpace')
                                      }}
                                    />
                                    <div className='text-danger fw-bold'>
                                      {error[0].availableSpace}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row mt-5'>
                                  <div className='col-lg-12'>
                                    <label className='fs-2 fw-bolder form-label'>
                                      {t('Available Dates')}
                                    </label>
                                  </div>
                                  <div className='col-lg-12 my-3'>
                                    <span className='fw-bolder fs-5 form-label'>
                                      {t('*Note:')}
                                      <span
                                        className='fs-7 form-label'
                                        style={{fontStyle: 'italic'}}
                                      >
                                        {' '}
                                        {t(
                                          'First select availability types, then you can set availability from date range of above start date and end date and click on apply button. Or you can directly click on calender date box for single date selection.'
                                        )}
                                      </span>
                                    </span>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-5 form-label'>
                                      {t('Availability Types')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Select
                                      name='availableType[]'
                                      id='availableTypeList'
                                      placeholder={t('Select Availability Types')}
                                      isSearchable={true}
                                      options={availableTypeList}
                                      value={availableTypeSelectedOptions}
                                      onChange={(e: any) => {
                                        setAvailableTypeSelectedOptions(e)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-8 my-3'>
                                    <div className='row'>
                                      <div className='col-lg'>
                                        {/* <!--begin::Label--> */}
                                        <label className='fs-5 form-label'>{t('Start Date')}</label>
                                        {/* <!--end::Label--> */}
                                        <input
                                          type='date'
                                          name='startAvailableDate'
                                          className='form-control mb-2'
                                          value={startAvailableDate}
                                          onChange={(e) => {
                                            setStartAvailableDate(e.target.value)
                                            removeError('startAvailableDate')
                                          }}
                                        />
                                      </div>
                                      <div className='col-lg'>
                                        {/* <!--begin::Label--> */}
                                        <label className='fs-5 form-label'>{t('End Date')}</label>
                                        {/* <!--end::Label--> */}
                                        <input
                                          type='date'
                                          name='endAvailableDate'
                                          className='form-control mb-2'
                                          value={endAvailableDate}
                                          onChange={(e) => {
                                            setEndAvailableDate(e.target.value)
                                            removeError('endAvailableDate')
                                          }}
                                        />
                                      </div>
                                      <div className='col-lg d-flex align-items-end'>
                                        <button
                                          className='btn btn-primary mb-2 mx-1'
                                          onClick={ApplyAvailableDates}
                                        >
                                          {t('Apply')}
                                        </button>
                                        <button
                                          className='btn btn-danger mb-2 mx-1'
                                          onClick={clearAvailableDates}
                                        >
                                          {t('Clear')}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='col-lg-12 my-5'>
                                    <Calendar
                                      localizer={localizer}
                                      events={events}
                                      startAccessor='start'
                                      endAccessor='end'
                                      selectable
                                      onSelectSlot={handleSelectSlot}
                                      style={{height: 500}}
                                      eventPropGetter={eventStyleGetter}
                                      onSelectEvent={(event: CustomEvent) =>
                                        handleRemoveEvent(event)
                                      }
                                      views={[Views.MONTH]}
                                    />
                                  </div>
                                  <div className='text-danger fw-bold'>
                                    {error[0].availableDate}
                                  </div>
                                </div>
                                <StepErrorAlert
                                  message={priceStepError}
                                  actionLabel={t('Go To Regular Price')}
                                  onAction={() => setPriceTab('RegularPrice')}
                                />
                                <div className='row'>
                                  <div className='col-lg-12'>
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button
                                        type='button'
                                        className='btn btn-light-primary me-4'
                                        onClick={() => setPriceTab('SpecialPrice')}
                                      >
                                        {t('Back')}
                                      </button>
                                      <button
                                        type='button'
                                        disabled={disable}
                                        className='btn btn-primary me-4'
                                        onClick={nextToRentableSpacePhotos}
                                      >
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span
                                            className='spinner-border spinner-border-sm mx-2'
                                            role='status'
                                            aria-hidden='true'
                                          ></span>
                                        )}
                                      </button>{' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div
                            className={clsx('tab-pane', {active: tab === 'RentableSpacePhotos'})}
                          >
                            <div className='row'>
                              <div className='col-lg-12'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>{t('Upload images')}</label>
                                {/* <!--end::Label--> */}
                                <br />
                                <input
                                  ref={inputfileRef}
                                  style={{display: 'none'}}
                                  className='modaldocument'
                                  type='file'
                                  onChange={handleImageChange}
                                  accept='image/*'
                                  multiple
                                />
                                <div className='d-flex flex-wrap align-items-center gap-3'>
                                  <span
                                    className='btn btn-light text-primary cursor-pointer '
                                    onClick={handleTextClick}
                                  >
                                    {' '}
                                    {t('Attach Images')}
                                  </span>
                                  <ReorderButton reorder={reorder} />
                                </div>
                                <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                                <UploadedImageGrid
                                  reorder={reorder}
                                  images={uploadedImage}
                                  onRemove={handleRemoveImage}
                                />
                                <NewImageGrid
                                  reorder={reorder}
                                  files={inputImage}
                                  onRemove={handleRemove1}
                                />
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('PricingAndAvailability')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={nextToAdditionalOptions}
                                  >
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === 'AdditionalOptions'})}>
                            {additionalFields.map((field: any, index: any) => {
                              return (
                                <div key={index} className='mb-5'>
                                  <div
                                    className='dropzone border-success bg-light-success mb-2'
                                    id='kt_ecommerce_add_reject_reason'
                                  >
                                    <div className='text-start needsclick'>
                                      {/* <!--begin::Icon--> */}
                                      <i className='fas fa-info-circle text-success fs-5 mt-1'></i>
                                      {/* <div className="ms-4"> */}
                                      <span className='fs-7 fw-semibold text-gray-600 mx-2'>
                                        ”
                                        {t(
                                          'Add any additional services you offer as options to your rental space. This can be anything from offering decorations to providing equipment or etc. Feel free to add as many as possible to increase your sales with extra offers'
                                        )}
                                        ”
                                      </span>
                                      {/* </div> */}
                                    </div>
                                  </div>
                                  {primaryLanguage == 'English' && (
                                    <>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.en_name}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'en_name')
                                            }}
                                          />
                                          {errors[index]?.en_name && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].en_name}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.ru_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.uz_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.en_description}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'en_description')
                                            }}
                                          />
                                          {errors[index]?.en_description && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].en_description}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.ru_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.uz_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage == 'Russian' && (
                                    <>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.ru_name}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'ru_name')
                                            }}
                                          />
                                          {errors[index]?.ru_name && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].ru_name}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.en_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.uz_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.ru_description}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'ru_description')
                                            }}
                                          />
                                          {errors[index]?.ru_description && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].ru_description}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.en_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.uz_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage == 'Uzbek' && (
                                    <>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.uz_name}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'uz_name')
                                            }}
                                          />
                                          {errors[index]?.uz_name && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].uz_name}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.ru_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Name (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_name'
                                            className='form-control mb-2'
                                            placeholder={t('Option Name')}
                                            value={field.en_name}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Uzbek)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='uz_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.uz_description}
                                            onChange={(e) => {
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                              removeErrors(index, 'uz_description')
                                            }}
                                          />
                                          {errors[index]?.uz_description && (
                                            <div className='text-danger fw-bold'>
                                              {errors[index].uz_description}
                                            </div>
                                          )}
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (Russian)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='ru_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.ru_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className='col-lg-4 my-3'>
                                          <label className='fs-5 form-label'>
                                            {t('Option Description (English)')}
                                          </label>
                                          <input
                                            type='text'
                                            name='en_description'
                                            className='form-control mb-2'
                                            placeholder={t('Option Description')}
                                            value={field.en_description}
                                            onChange={(e) =>
                                              handleAdditionalInputChange(
                                                index,
                                                e.target.name,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <div className='row'>
                                    <div className='col-lg-4 my-3'>
                                      <label className='fs-5 form-label'>
                                        {t('Max Use Capacity')}
                                      </label>
                                      <input
                                        type='text'
                                        name='maxUseCapacity'
                                        className='form-control mb-2'
                                        placeholder={t('Max Use Capacity')}
                                        value={field.maxUseCapacity}
                                        onChange={(e) => {
                                          handleAdditionalInputChange(
                                            index,
                                            e.target.name,
                                            e.target.value
                                          )
                                          removeErrors(index, 'maxUseCapacity')
                                        }}
                                      />
                                      {errors[index]?.maxUseCapacity && (
                                        <div className='text-danger fw-bold'>
                                          {errors[index].maxUseCapacity}
                                        </div>
                                      )}
                                    </div>
                                    <div className='col-lg-4 my-3'>
                                      <PriceInput
                                        labelClass='fs-6 form-label'
                                        label={t('Option Price')}
                                        inputClass='form-control border-right-0'
                                        placeholder={t('Space Price')}
                                        value={field.spacePrice}
                                        onChange={(value: any) => {
                                          handleAdditionalInputChange(index, 'spacePrice', value)
                                          removeErrors(index, 'spacePrice')
                                        }}
                                      />
                                      {errors[index]?.spacePrice && (
                                        <div className='text-danger fw-bold'>
                                          {errors[index].spacePrice}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className='row my-2'>
                                    <div className='col-lg-8'>
                                      <div className='mt-5' id='additionalImage'>
                                        <FileUploader
                                          multiple={false}
                                          handleChange={(image: any) => {
                                            handleAdditionalImageChange(index, image)
                                            removeErrors(index, 'additionalImage')
                                          }}
                                          name='additionalImage'
                                          types={fileTypes}
                                          classes='w-100'
                                        >
                                          <div
                                            className='dropzone border-success bg-light-success dz-clickable'
                                            id='kt_ecommerce_add_business_certificate'
                                          >
                                            <i className='ki-outline ki-file-up text-success fs-3x'></i>
                                            <div className='ms-4'>
                                              <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                                                {t('Upload Image')}
                                              </h3>
                                              <span className='fs-7 fw-semibold text-gray-500'>
                                                {t('Drag & Drop or choose files from computer')}
                                              </span>
                                            </div>
                                          </div>
                                        </FileUploader>
                                        {errors[index]?.additionalImage && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].additionalImage}
                                          </div>
                                        )}
                                        {field.additionalImage ? (
                                          <div
                                            className='mt-3'
                                            style={{position: 'relative', display: 'inline-block'}}
                                          >
                                            <div
                                              className='shadow-sm rounded-4'
                                              style={{
                                                maxWidth: 'fit-content',
                                                width: '300px',
                                                height: '200px',
                                              }}
                                            >
                                              {(field.additionalImage as any) instanceof File ? (
                                                // If menuImage is a file object (during add time)
                                                <a
                                                  href={URL.createObjectURL(field.additionalImage)}
                                                  target='_blank'
                                                >
                                                  <img
                                                    className='p-2 rounded-4'
                                                    src={URL.createObjectURL(field.additionalImage)}
                                                    width='100%'
                                                    style={{width: '300px', height: '200px'}}
                                                  />
                                                </a>
                                              ) : (
                                                // If menuImage is a URL (during edit time)
                                                <a href={field.additionalImage} target='_blank'>
                                                  <img
                                                    className='p-2 rounded-4'
                                                    src={field.additionalImage}
                                                    width='100%'
                                                    style={{width: '300px', height: '200px'}}
                                                  />
                                                </a>
                                              )}
                                            </div>
                                            <button
                                              className='btn btn-danger rounded-circle position-absolute'
                                              style={{
                                                width: '20px', // Adjust to your preferred size
                                                height: '20px',
                                                fontSize: '12px',
                                                top: '-8px', // Slight offset above the image border
                                                right: '-8px', // Slight offset to the right of the image border
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0',
                                                zIndex: 10,
                                              }}
                                              onClick={() => handleRemoveAdditionalImage(index)}
                                            >
                                              X
                                            </button>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                    <div className='col-lg-4 my-3 d-flex align-items-end justify-content-end'>
                                      <button
                                        className='btn btn-success mx-1'
                                        onClick={handleAddAdditionalField}
                                      >
                                        +
                                      </button>
                                      {index > 0 && (
                                        <button
                                          className='btn btn-danger mx-1'
                                          onClick={() => handleRemoveAdditionalField(index)}
                                        >
                                          -
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                            {/* <!--end::Input group--> */}
                            <div className='row mt-5'>
                              <div className='col-lg-12'>
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button
                                    type='button'
                                    className='btn btn-light-primary me-4'
                                    onClick={() => setTab('RentableSpacePhotos')}
                                  >
                                    {t('Back')}
                                  </button>
                                  <button
                                    type='button'
                                    disabled={disable}
                                    className='btn btn-primary me-4'
                                    onClick={() => {
                                      if (editRentableSpaceId !== '') {
                                        editRentableSpaceApi()
                                      } else {
                                        addRentableSpaceApi()
                                      }
                                    }}
                                  >
                                    <span className='indicator-label'>{t('Submit')}</span>
                                    {loading && (
                                      <span
                                        className='spinner-border spinner-border-sm mx-2'
                                        role='status'
                                        aria-hidden='true'
                                      ></span>
                                    )}
                                  </button>{' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--end::Controls--> */}
                    </div>
                    {/* <!--end::Dropzone--> */}
                  </div>
                  {/* <!--end::Input group--> */}
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export {ViewRentableSpaces}
